// TODO: confirm with client
export const b2bFirstOrderDiscountMinimumWeightGrams = 15_000;
